import { KCTokenParsed, JWTTokenParsed } from 'dto/user.dto';
import { createStore, createEvent } from 'effector';

export const $coordinate = createStore<{ latitude?: number; longitude?: number } | undefined>({});

export const setCoordinate = createEvent<{ latitude: number; longitude: number } | undefined>();

export const $user = createStore<Partial<(JWTTokenParsed & KCTokenParsed) | null>>(null);

export const setUser = createEvent<Partial<JWTTokenParsed & KCTokenParsed>>();

export const resetUser = createEvent();

$user
	.on(setUser, (state, payload) => {
		return { ...state, ...payload };
	})
	.on(resetUser, () => null);

$coordinate.on(setCoordinate, (state, payload) => {
	return payload;
});
